import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://alliancecraneservice.com";

export default function SEO({ title, description, canonical }) {
  const location = useLocation();
  const fullTitle = title
    ? `${title} | Alliance Crane Service LLC`
    : "Alliance Crane Service LLC | Mobile Crane Rental — DeLand, FL";
  const url = canonical || `${BASE_URL}${location.pathname}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
    </Helmet>
  );
}
